import { render, staticRenderFns } from "./ModalUnsubscribe.vue?vue&type=template&id=b8143b80&scoped=true&"
import script from "./ModalUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./ModalUnsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./ModalUnsubscribe.vue?vue&type=style&index=0&id=b8143b80&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8143b80",
  null
  
)

export default component.exports